export class ContactUtil {
  static getRequestGoogleFormUrl(url: string, email: string): string {
    const requestFormUrl = url.replace('<email>', email);
    return requestFormUrl;
  }
}
